import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// mui
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Drawer from '@mui/material/Drawer';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import LinearProgress from '@mui/material/LinearProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

// Our components
import Notification from './Notification'
import BulkOrderDrawer from './BulkOrderDrawer'
import WidthMaximize from './WidthMaximize'

// slice
import { uploadBulkOrder, fetchBulkOrderDetail, resetBulkOrders } from '../../pages/BulkOrder/bulkOrderSlice';

const Input = styled('input')({
    display: 'none',
});

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    boxShadow: 'unset',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.secondary,
}));

// Shared form component standard configuration matching enterprise layouts
const enterpriseBulkInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE IDENTITY BRAND BLUE ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & textarea': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const BulkOrderCreateDrawer = ({ visible, onClose }) => {
    const dispatch = useDispatch();

    // state
    const bulkorder = useSelector(state => state.bulkorder && state.bulkorder.uploadorder);
    const profile = useSelector(state => state.auth);
    const [drawer, setDrawer] = useState(true);
    const [fileUpload, setFileUpload] = useState("")
    const [fileName, setFileName] = useState("")
    const [bulkOrderDrawerVisible, setBulkOrderDrawerVisible] = useState(false);
    const [referenceId, setReferenceId] = useState("");
    const [buttonDisabled, setbuttonDisabled] = useState(true)
    const [uploadType, setUploadType] = useState("SHIPMENT")
    const [notes, setNotes] = useState("")
    const [drawerWidth, setDrawerWidth] = useState("80%");

    const bulkOrderCallback = (item) => {
        // setReferenceId(item)
        dispatch(fetchBulkOrderDetail(item));
        setBulkOrderDrawerVisible(true)
    }
    const bulkOrderOnClose = (values) => {
        setBulkOrderDrawerVisible(false);
    };
    const onFileUpload = (e) => {
        e.preventDefault()
        if (e.target.files && e.target.files.length === 0) {
            setFileName(fileUpload.name)
            setFileUpload(fileUpload);
        } else {
            setFileUpload(e.target.files[0]);
            setFileName(e.target.files[0].name)
        }
        setbuttonDisabled(false)
    }

    const onSubmit = () => {
        let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
        var formData = new FormData();
        formData.append('file', fileUpload);
        formData.append("subuser_id", profile.profile.id);
        dispatch(uploadBulkOrder(profile.profile.id,formData, apikey, uploadType,notes))
        setFileName("")
        setFileUpload("")
        setbuttonDisabled(true)
    }

    const ondrawerclose = () => {
        dispatch(resetBulkOrders())
        setFileName("")
        setReferenceId("")
        setbuttonDisabled(true)
        setDrawer(false)
        onClose(false)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(e.target.value === "ORDER"){
            setUploadType("ORDER")
        }else{
            setUploadType("SHIPMENT")
        }
    };

    useEffect(() => {
        if ((bulkorder && bulkorder.notification && bulkorder.notification.show && bulkorder.notification.messageType === 'success')) {
            setReferenceId(bulkorder && bulkorder.order && bulkorder.order.reference_id)
            setFileName("")
            setbuttonDisabled(true)
        }
    }, [bulkorder])

    return (
        <>
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { 
                        width: drawerWidth,
                        backgroundColor: '#F8FAFC',
                        borderLeft: '1px solid #E2E8F0'
                    },
                }}
            >
                {(bulkorder && bulkorder.notification && bulkorder.notification.show && bulkorder.notification.messageType === 'success') &&
                    <Notification
                        is_open={bulkorder.notification.show}
                        messageType={bulkorder.notification.messageType}
                        messages={bulkorder.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrders())}
                    />}
                {(bulkorder && bulkorder.notification && bulkorder.notification.show && bulkorder.notification.messageType === 'error') &&
                    <Notification
                        is_open={bulkorder.notification.show}
                        messageType={bulkorder.notification.messageType}
                        messages={bulkorder.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrders())}
                    />}
                <Box sx={{ p: 3, width: '100%', boxSizing: 'border-box' }}>
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }}
                    >
                        <CardHeader 
                            title={
                                <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    Import Bulk Order
                                </Typography>
                            } 
                            action={
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <WidthMaximize
                                        defaultWidth="80%"
                                        onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                    />
                                    <IconButton 
                                        aria-label="settings" 
                                        onClick={ondrawerclose}
                                        sx={{ 
                                            color: '#64748B',
                                            '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: '20px' }} />
                                    </IconButton>
                                </Stack>
                            } 
                            sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                        />
                        
                        {bulkorder && bulkorder.loading === true && (
                            <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                        )}
                        
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <Box sx={{ p: 4, maxWidth: 580, mx: 'auto', width: '100%', boxSizing: 'border-box' }}>
                            
                            {/* Trace Lookup Notification Banner element */}
                            {referenceId && (
                                <Box sx={{ mb: 3.5, p: 2, bgcolor: 'rgba(25, 118, 210, 0.05)', border: '1px dashed #1976d2', borderRadius: '12px', textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 600, fontSize: '13.5px' }}>
                                        Check your Reference id:{' '}
                                        <strong 
                                            onClick={e => { bulkOrderCallback(referenceId) }}
                                            style={{ textDecoration: 'underline', color: '#1976d2', cursor: 'pointer', fontWeight: 800, marginLeft: '4px' }}
                                        >
                                            {referenceId}
                                        </strong>
                                    </Typography>
                                </Box>
                            )}

                            {/* Core Intercept Interactive Upload Drop Area Canvas Panel */}
                            <Box className="sc--form--center" sx={{ mb: 4, textAlign: 'center' }}>
                                <label htmlFor="contained-button-file">
                                    {fileName === '' && (
                                        <Input accept=".csv" id="contained-button-file" onChange={onFileUpload} key={fileName} multiple type="file" />
                                    )}
                                    <Stack spacing={2} alignItems="center" sx={{ p: 4, border: '2px dashed #E2E8F0', borderRadius: '14px', bgcolor: '#F8FAFC', cursor: fileName === '' ? 'pointer' : 'default', transition: 'all 0.2s', '&:hover': fileName === '' ? { borderColor: '#1976d2', bgcolor: 'rgba(25, 118, 210, 0.02)' } : {} }}>
                                        {fileName === '' ? (
                                            <CloudUploadIcon sx={{ fontSize: '40px', color: '#64748B' }} />
                                        ) : (
                                            <InsertDriveFileIcon sx={{ fontSize: '40px', color: '#1976d2' }} />
                                        )}
                                        
                                        <Button 
                                            variant="contained" 
                                            component="span" 
                                            disabled={fileName !== ''}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: '10px',
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                boxShadow: 'none',
                                                height: '36px',
                                                px: 3,
                                                backgroundColor: '#1976d2',
                                                '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                            }}
                                        >
                                            Upload CSV File
                                        </Button>
                                        
                                        <Link 
                                            href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/bulk_create_shipment/Bulk_Create_Shipment_Sample.csv"
                                            target="_blank"
                                            rel="noopener"
                                            sx={{ fontSize: '13px', fontWeight: 600, color: '#1976d2', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                                            onClick={(e) => e.stopPropagation()} // Shield upload click execution loops
                                        >
                                            Download sample orders CSV
                                        </Link>

                                        {fileName && (
                                            <Box sx={{ mt: 1, py: 0.5, px: 1.5, bgcolor: '#E2E8F0', borderRadius: '6px', maxWidth: '100%' }}>
                                                <Typography noWrap sx={{ fontSize: '12px', fontWeight: 700, color: '#475569' }}>
                                                    File: {fileName}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Stack>
                                </label>
                            </Box>

                            {/* Config Pipeline Processing Type Selection Core System Switches Wrapper */}
                            <Box className="sc--form--center" sx={{ mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <FormLabel id="upload-type-label" sx={{ fontSize: '12.5px', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1.5 }}>
                                    Processing Integration Profile
                                </FormLabel>
                                <RadioGroup
                                    aria-labelledby="upload-type-label"
                                    name="controlled-radio-buttons-group"
                                    value={uploadType}
                                    onChange={handleChange}
                                    row
                                    sx={{ gap: 2 }}
                                >
                                    <FormControlLabel 
                                        value="ORDER"  
                                        control={<Radio size="small" sx={{ color: '#CBD5E1', '&.Mui-checked': { color: '#1976d2' } }} />} 
                                        label={<Typography sx={{ fontSize: '12.5px', fontWeight: 700, color: '#334155' }}>ONLY ORDER</Typography>} 
                                    />
                                    <FormControlLabel 
                                        value="SHIPMENT" 
                                        control={<Radio size="small" sx={{ color: '#CBD5E1', '&.Mui-checked': { color: '#1976d2' } }} />} 
                                        label={<Typography sx={{ fontSize: '12.5px', fontWeight: 700, color: '#334155' }}>ORDER + SHIPMENT</Typography>} 
                                    />
                                </RadioGroup>
                            </Box>

                            {/* Additional Metadata Label Configuration Form Control Section */}
                            <Box className="sc--form--center" sx={{ mb: 4.5 }}>
                                <TextField
                                    label="Notes"
                                    name="notes"
                                    fullWidth
                                    size="small"
                                    inputProps={{ maxLength: 200 }}
                                    onInput={e => setNotes(e.target.value)}
                                    variant="outlined" 
                                    sx={enterpriseBulkInputStyles}
                                />
                            </Box>

                            {/* Execution Terminal Affirmation Action Panel Footer Button Trigger */}
                            <Box className="sc--form--center" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, pt: 1, borderTop: '1px solid #E2E8F0' }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={ondrawerclose}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 3.5,
                                        borderColor: '#E2E8F0',
                                        color: '#475569',
                                        '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={onSubmit} 
                                    disabled={buttonDisabled}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 5,
                                        boxShadow: 'none',
                                        backgroundColor: '#1976d2',
                                        color: '#FFFFFF',
                                        '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                        '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                    }}
                                >
                                    Submit File
                                </Button>
                            </Box>

                        </Box>
                    </Card>
                </Box>
            </Drawer >
            <BulkOrderDrawer
                visible={bulkOrderDrawerVisible} referenceId={referenceId} bulkDraweronClose={bulkOrderOnClose}
            />
        </>
    )
}

export default BulkOrderCreateDrawer;